import React, { type ReactNode } from 'react';
import { clsx, cn } from '@mentimeter/ragnar-tailwind-config';
import { IconButton } from '../../../../icon-button/icon-button/tw';
import type { InputVariantProps } from '../../../utils';
import {
  textInputVariant,
  type TextInputIconVariantProps,
} from './TextInputIcon.variants';

interface TextInputIcon extends Pick<TextInputIconVariantProps, 'iconType'> {
  icon: ReactNode;
  iconLabel?: string | undefined;
  iconAction?: (() => void) | undefined;
  inputSize?: InputVariantProps['size'];
}

export const TextInputIcon = ({
  icon,
  iconLabel = undefined,
  iconAction = undefined,
  inputSize,
  iconType,
  ...rest
}: TextInputIcon) => {
  if (!icon) return null;

  const defaultClasses = clsx(
    'flex',
    'flow-col',
    'items-center',
    'justify-center',
    'h-full',
  );

  const textInputIconClasses = textInputVariant({
    iconAction: Boolean(iconAction),
    inputSize,
    iconType,
  });

  return (
    <div
      className={cn(defaultClasses, textInputIconClasses)}
      aria-hidden={!iconAction}
      {...rest}
    >
      {iconAction ? (
        <IconButton
          aria-label={iconLabel}
          onClick={iconAction}
          variant="secondary"
          size="compact"
        >
          {icon}
        </IconButton>
      ) : (
        icon
      )}
    </div>
  );
};
